import camelcaseKeys from 'camelcase-keys';
import ProviderLogsAPI from 'dashboard/api/providerLogs';
import { throwErrorMessage } from 'dashboard/store/utils/api';
import { defineStore } from 'pinia';

const createInitialMeta = () => ({ totalCount: 0, currentPage: 1 });

// Backs the account-level "message logs" tab (observability for the UAZAPI
// provider): fetches the paginated, filterable list served by
// GET /api/v1/accounts/:account_id/provider_logs (`{ meta, payload }`).
export const useProviderLogsStore = defineStore('providerLogs', {
  state: () => ({
    records: [],
    meta: createInitialMeta(),
    uiFlags: { isFetching: false },
    fetchRequestToken: 0,
  }),

  actions: {
    async fetchLogs(params = {}) {
      this.uiFlags.isFetching = true;
      this.fetchRequestToken += 1;
      const requestToken = this.fetchRequestToken;
      try {
        const { data } = await ProviderLogsAPI.get(params);
        // A newer fetch (filter/page change) superseded this one; drop the result.
        if (this.fetchRequestToken !== requestToken) return this.records;
        this.records = camelcaseKeys(data.payload || [], { deep: true });
        this.meta = camelcaseKeys(data.meta || {});
        return this.records;
      } catch (error) {
        // Don't surface errors from a fetch that a newer request already replaced.
        if (this.fetchRequestToken !== requestToken) return this.records;
        this.records = [];
        this.meta = createInitialMeta();
        return throwErrorMessage(error);
      } finally {
        if (this.fetchRequestToken === requestToken) {
          this.uiFlags.isFetching = false;
        }
      }
    },
  },
});
